import React, { useMemo } from 'react';

const RESULT_COLORS = {
  'Home Run': 'text-[#c4333e]',
  'Double': 'text-[#d8ceb3]',
  'Triple': 'text-[#d8ceb3]',
  'Single': 'text-white',
  'Strikeout': 'text-[#658d71]',
  'Walk': 'text-[#a9c9b1]',
};

const KeyPlays = ({ allPlays }) => {
  const keyPlays = useMemo(() => {
    if (!allPlays?.length) return [];
    return allPlays
      .filter(p => {
        const rbi = p.result?.rbi ?? 0;
        const event = p.result?.event ?? '';
        return rbi >= 1 || ['Home Run', 'Triple', 'Double'].includes(event);
      })
      .slice(-20)
      .reverse()
      .slice(0, 12);
  }, [allPlays]);

  if (!keyPlays.length) return (
    <div className="text-[#658d71] text-xs tracking-widest uppercase text-center py-6">
      No key plays available
    </div>
  );

  return (
    <div className="flex flex-col gap-1 max-h-[280px] overflow-y-auto pr-1">
      {keyPlays.map((play, i) => {
        const event = play.result?.event || '--';
        const desc = play.result?.description || '';
        const inning = play.about?.inning;
        const isTop = play.about?.isTopInning;
        const rbi = play.result?.rbi;
        const colorClass = RESULT_COLORS[event] || 'text-white';
        return (
          <div key={i} className="border border-[rgba(101,141,113,0.4)] p-2 bg-[rgba(0,0,0,0.1)] flex gap-3 items-start">
            <div className="shrink-0 text-[9px] font-bold text-[#a9c9b1] uppercase tracking-widest pt-0.5 w-12 text-center">
              {isTop ? '▲' : '▼'}{inning}
            </div>
            <div className="flex flex-col gap-0.5 min-w-0">
              <div className="flex items-center gap-2">
                <span className={`text-[10px] font-black uppercase tracking-wider ${colorClass}`}>{event}</span>
                {rbi > 0 && (
                  <span className="text-[9px] bg-[#c4333e] text-white px-1 font-bold">{rbi} RBI</span>
                )}
              </div>
              <p className="text-[10px] text-[#a9c9b1] leading-tight line-clamp-2">{desc}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default KeyPlays;